import { InjectionToken, Type } from '@angular/core'

import { Observable } from 'rxjs'

import { AppFeatures, PermissionCondition } from '@ti/contracts'

export interface iMenuElement {
  name: string
  path: string[]
  icon?: Type<unknown>
  children?: iMenuElement[]
  isExpanded?: boolean
  cssClass?: string
  counterKey?: string
  actionButton?: Pick<iMenuElement, 'name' | 'path' | 'icon' | 'checkAccess'>
  checkAccess?: PermissionCondition
  requirePricingPlan?: AppFeatures[]
  isExperimentalFeature?: boolean
  hidden?: boolean
  disabled?: boolean
}

export interface InstallPromptResult {
  outcome: 'accepted' | 'dismissed'
  platform: string
}

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<InstallPromptResult>
  userChoice: Promise<InstallPromptResult>
}

export interface SidebarCounters {
  newMediaLibraryItems: number
  unreviewedAlerts: number
  chatTotalUnreadCount: number
  overdueAndSoonVehicleServicesCount: number
  needsAttentionInspectionReportsCount: number
}

export enum UpdateReason {
  Manual = 'manual',
  BulkStatusChange = 'bulk-status-change',
  IndividualStatusChange = 'individual-status-change',
  Push = 'push',
  Realtime = 'realtime',
}

export interface RefreshUnreviewedAlertsCountOptions {
  reason?: UpdateReason
}

export interface ISidebarBadgesModel {
  state: {
    counters$: Observable<Record<string, any>> // Observable<SidebarCounters>
  }

  init(): Promise<void> | void
  countersDataStream(): Observable<Record<string, any>> // Observable<SidebarCounters>
  refreshUnreviewedAlertsCount(options?: RefreshUnreviewedAlertsCountOptions): Promise<void> | void
  refreshNewMediaLibraryItemsCount(): Promise<void> | void
  refreshOverdueAndSoonVehicleServicesCount(): Promise<void> | void
  refreshNeedsAttentionInspectionReportsCount(): Promise<void> | void
  loadUnreviewedAlertsCount(): Promise<void> | void
  loadNewMediaLibraryItemsCount(): Promise<void> | void
  loadOverdueAndSoonVehicleServicesCount(): Promise<void> | void
  loadNeedsAttentionInspectionReportsCount(): Promise<void> | void
}

export const SIDEBAR_BADGES_MODEL = new InjectionToken<ISidebarBadgesModel>('SIDEBAR_BADGES_MODEL')
